module.exports = __webpack_public_path__ + "img/sort-icon-3.d66ad97d.png";